export function resolveParentMessageOrigin(): string | null {
  const params = new URLSearchParams(globalThis.location.search);
  const fromQuery = params.get("parent_origin");
  if (fromQuery) {
    try {
      return new URL(fromQuery).origin;
    } catch {
      return null;
    }
  }

  if (document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch {
      return null;
    }
  }

  return null;
}
